
<script setup>

defineProps( [ 'size' ] )

</script>

<template>

  <button class="rounded-full cursor-pointer text-center font-bold capitalize" :class="[ size === 'sm' ? 'px-6 py-2 text-sm' : 'sm:px-10 py-3 text-base' ]">

    <slot></slot>

  </button>

</template>